/**
 * Maps Firebase Auth error codes to user-friendly messages.
 * Firebase's raw error.message (e.g. "Firebase: Error (auth/user-not-found).")
 * is too technical to show directly in the UI.
 */
export function getAuthErrorMessage(error: unknown): string {
  const code = (error as { code?: string } | undefined)?.code ?? "";

  switch (code) {
    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential":
      return "Incorrect email or password. Please try again.";
    case "auth/invalid-email":
      return "Please enter a valid email address.";
    case "auth/user-disabled":
      return "This account has been disabled. Contact support for help.";
    case "auth/too-many-requests":
      return "Too many failed attempts. Please wait a moment and try again.";
    case "auth/network-request-failed":
      return "Network error. Please check your connection and try again.";
    case "auth/email-already-in-use":
      return "An account with this email already exists.";
    case "auth/weak-password":
      return "Password should be at least 6 characters.";
    case "auth/popup-closed-by-user":
      return "Sign-in was cancelled.";
    case "auth/popup-blocked":
      return "Sign-in popup was blocked by your browser. Please allow popups and try again.";
    case "auth/requires-recent-login":
      return "Please sign in again to continue.";
    default: {
      const message = (error as { message?: string } | undefined)?.message ?? "";
      // Avoid leaking raw "Firebase: Error (auth/...)." strings to the user.
      if (!message || message.startsWith("Firebase:")) {
        return "Something went wrong. Please try again.";
      }
      return message;
    }
  }
}
